define(
  'connections/userimport-connection',[
    'jquery',

    'utils/ajax-util',

    'settings',
  ],

  function ($, ajax, settings) {
    /**
     * @class UserImportConnection
     */
    return (function () {

      /**
       * @constructor
       */
      function UserImportConnection() { }

      UserImportConnection.prototype.checkUserNotExist = function (email) {
        return ajax.post(settings.userImportCheckUserExistApiUrl, { username: email });
      };

      UserImportConnection.prototype.getCompanyName = function (cid) {
        return ajax.get(settings.businessPartnerUrl.replace(':cid', cid));
      };

      return new UserImportConnection();
    })();
  }
);
